type URLParamType = {
  [key: string]: string
};

export function getURLParams(link: string): URLParamType {
  if(typeof link !== 'string') {
    throw new Error('"link" should be a string');
  }

  const params: { [key: string]: string } = {};

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [origin, ...rest]: string[] = link.split('?');
  /* eslint-enable @typescript-eslint/no-unused-vars */
  const paramsArr: string[] = rest.join('?').split('&');

  if(paramsArr.length) {
    paramsArr.forEach((param: string) => {
      const [key, value] = param.split('=');

      if(key) {
        params[key] = value;
      }
    });

    return params;
  }

  return {};
}


export function setURLParam(url: string, key: string, value: string): string {
  if(typeof url !== 'string' || typeof key !== 'string' || typeof value !== 'string') {
    throw new Error('All params should be strings');
  }

  const [origin]: string[] = url.split('?');
  const params: URLParamType = getURLParams(url);
  let resultString: string = '';

  params[key] = value;

  Object.keys(params).forEach((el: string) => {
    if(resultString.length) {
      resultString += `&${el}=${params[el]}`;
    } else {
      resultString += `?${el}=${params[el]}`;
    }
  });

  return origin + resultString;
}
